import { render, staticRenderFns } from "./jy-valueAddedServicesDetail.vue?vue&type=template&id=059bc339&scoped=true&"
import script from "./jy-valueAddedServicesDetail.vue?vue&type=script&lang=js&"
export * from "./jy-valueAddedServicesDetail.vue?vue&type=script&lang=js&"
import style0 from "./jy-valueAddedServicesDetail.vue?vue&type=style&index=0&id=059bc339&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059bc339",
  null
  
)

export default component.exports